// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a user loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/flightlog/:flightlogid\",\"regex\":\"^/flightlog/([^/]+)$\",\"paramNames\":[\"flightlogid\"],\"hasOptionalPrefix\":false},{\"path\":\"/statement/:userId\",\"regex\":\"^/statement/([^/]+)$\",\"paramNames\":[\"userId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/aircraftsettings\"},{\"path\":\"/calendar\"},{\"path\":\"/finances\"},{\"path\":\"/flightlog\"},{\"path\":\"/performance\"},{\"path\":\"/statement\"},{\"path\":\"/statement/teststatement\"},{\"path\":\"/user\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.GLITCH_DSN,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

// App Router navigation instrumentation (Sentry v10 / Next.js 15.3+)
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
